<template>
    <div class="fullpage-container">
      <div class="connect_icon animate__animated animate__heartBeat">
        <div class='phone_number ' >
        <i class="el-icon-user-solid">: 0571-89001550</i><p/>
        <i class="el-icon-user-solid">: 15384013886</i>
        </div>
      </div>
      <div class="fullpage-wp" v-fullpage="opts" ref="example">
        <div class="page-1 page">
          <div class="Menu-Box">
            <a href="https://shop7846766590635.1688.com/?spm=a2615work.11851524.0.0.VjoXbe" target="_blank"><div class="Menu-logo"></div></a>
            <ul class="clearfix" >
              <li class v-for="(m,i) in menu_item" :key="m" class="Menu-nav"  :class="{ Menu_active:changeActive == i}" @click="active_menu(i)" ref='li_menu'>
                {{m}}
              </li>
            </ul>
          </div>
          <a href="https://shop7846766590635.1688.com/?spm=a2615work.11851524.0.0.VjoXbe" target="_blank">
            <div class="more-pro animate__animated" :class="{animate__flipInX:animationIsShow_1}" style="position: absolute;z-index:9997;bottom: 20%;left:0;right:0;padding:4%;">阿里巴巴店铺>></div>
          </a>
          <el-carousel :interval="5000" arrow="never" :autoplay="true" :height="screenHeight">
              <el-carousel-item v-for="(item,i) in pic_list" :key="i">
                <img :src="item" style="width:100%">
              </el-carousel-item>
          </el-carousel>
          <div class="xiala-icon element-animation" ></div>
            <!-- <p class="part-1" v-animate="{value: 'bounceInLeft'}">fullpage-vue</p> -->
        </div>
        <div class="page-2 page">
          <div class="Menu-Box">
            <a href="https://shop7846766590635.1688.com/?spm=a2615work.11851524.0.0.VjoXbe" target="_blank"><div class="Menu-logo"></div></a>
            <ul class="clearfix" >
              <li class v-for="(m,i) in menu_item" :key="m" class="Menu-nav"  :class="{ Menu_active:changeActive == i}" @click="active_menu(i)" ref='li_menu'>
                {{m}}
              </li>
            </ul>
          </div>
          <div style="margin-top:200px;position:relative">
            <el-carousel :interval="60000" @change="changeFun" @click.native="linkTo"  ref="carousel" type="card" :height="card_Height" class="animate__animated" :class="{animate__fadeInLeft:animationIsShow_2}" >
              <el-carousel-item v-for="(item ,index) in display_list" :key="index">
                <img :src="item.pic" style="width: 100%; max-height: 100%;" />
                <!-- <h3 class="medium">{{ item }}</h3> -->
              </el-carousel-item>
            </el-carousel>
            <div class="more-pro animate__animated  " :class="{animate__fadeInRight:animationIsShow_2}" style="postion:absolute" @click="goto_prolist">more>></div>
          </div>
          <div class="xiala-icon element-animation"></div>
          <!-- <p class="part-2" v-animate="{value: 'bounceInRight'}">fullpage-vue2</p> -->
        </div>
        <div class="page-3 page">
          <div class="Menu-Box">
            <a href="https://shop7846766590635.1688.com/?spm=a2615work.11851524.0.0.VjoXbe" target="_blank"><div class="Menu-logo"></div></a>
            <ul class="clearfix" >
              <li class v-for="(m,i) in menu_item" :key="m" class="Menu-nav"  :class="{ Menu_active:changeActive == i}" @click="active_menu(i)" ref='li_menu'>
                {{m}}
              </li>
            </ul>
          </div>
          <div class="pro-nav">
            <el-row class="tac" style="background-color: transparent;">
              <el-col :span="4">
                <!-- <h5>自定义颜色</h5> -->
                <el-menu
                  @select="handleSelect"
                  default-active="0"
                  class="el-menu-vertical-demo"
                  background-color=transparent
                  text-color="#fff"
                  active-text-color="#ffd04b">
                  <el-menu-item :index="i+''" v-for="(item,i) in pro_nav_item" :key="(item,i)"  >
                    <i class="el-icon-star-on"></i>
                    <span slot="title">{{item.name}}</span>
                  </el-menu-item>
                </el-menu>
              </el-col>
              <el-col :span="20">
              <el-row>
                <el-col :span="5" v-for="(o, index) in (show_pros.length>8?show_pros.splice(8,show_pros.length-8):show_pros)" :key="index" :offset="1" style="margin-top:10px;" >
                  <el-card :bodyStyle="list_card_style" class="animate__animated" :class="{animate__fadeInLeft:(animationIsShow_3 && (index%4==0 || index%4==1)),
                  animate__fadeInRight:(animationIsShow_3 && (index%4==2 || index%4==3))}" >
                    <img :src="o.pic" class="image" @click="single_pro_click(index)">
                    <!-- 25px 0px 0px 10px; -->
                    <div class="item_name">
                      <span>{{o.name}}</span>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
              </el-col>
            </el-row>
            <el-pagination
              style="margin-left: 19.5%;padding: 14px 5px;"
              :page-size="8"
              :hide-on-single-page="current_pos.length>8?false:true"
              @current-change="current_change"
              background
              layout="prev, pager, next"
              :total="current_pos.length">
            </el-pagination>
          </div>
          <div class="xiala-icon element-animation" ></div>
        </div>
        <div class="page-4 page">
          <div class="Menu-Box">
            <a href="https://shop7846766590635.1688.com/?spm=a2615work.11851524.0.0.VjoXbe" target="_blank"><div class="Menu-logo"></div></a>
            <ul class="clearfix" >
              <li class v-for="(m,i) in menu_item" :key="m" class="Menu-nav"  :class="{ Menu_active:changeActive == i}" @click="active_menu(i)" ref='li_menu'>
                {{m}}
              </li>
            </ul>
          </div>
          <div class="jianjie">
            <img :src="jianjie" />
          </div>
          <div class="xiala-icon element-animation" ></div>
        </div>
        <div class="page-5 page">
          <div class="Menu-Box">
            <a href="https://shop7846766590635.1688.com/?spm=a2615work.11851524.0.0.VjoXbe" target="_blank"><div class="Menu-logo"></div></a>
            <ul class="clearfix" >
              <li class v-for="(m,i) in menu_item" :key="m" class="Menu-nav"  :class="{ Menu_active:changeActive == i}" @click="active_menu(i)" ref='li_menu'>
                {{m}}
              </li>
            </ul>
          </div>
          <div class="connect_us">
            <div style="float:left">
              <h1 style="color:white;padding:0 18px">联系我们</h1>
              <div style="padding:1px;background:#7bb9e4;height:1px"></div>
              <ul>
                <li>
                  <i class="el-icon-user"></i>
                  电话：15384013886
                </li>
                <li>
                  <i class="el-icon-phone"></i>
                  座机：0571-89001550
                </li>
                <li>
                  <i class="el-icon-message"></i>
                  邮箱：business@hzmfzl.com
                </li>
                <li>
                  <i class="el-icon-position"></i>
                    <a href="https://uri.amap.com/marker?position=120.118021,30.344129&name=杭州美氟制冷科技有限公司" target="_black" style="text-decoration: none;color: white;">
                      地址：杭州市拱墅区祥运路8号
                    </a>
                </li>
              </ul>
            </div>
            <div style="float:right;">
              <iframe width="504" height="425" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="http://j.map.baidu.com/s/2sxIFb"></iframe>
            </div>
            <div style="clear:both"></div>
          </div>
          <div style="width: 100%;height: 70px;position: absolute;left: 0;bottom:20px;">
            <div class="beian">
              <!-- <p>杭州美氟制冷科技有限公司</p> -->
              <a style="color: white;text-decoration: none;" href="http://beian.miit.gov.cn/">浙ICP备19013774号-1</a></div>
          </div>
        </div>
      </div>
      <!-- <button @click="moveNext">next</button> -->
      <el-drawer
        :visible.sync="drawer"
        custom-class="d_aa"
        size='40%'
        :direction="direction"
        :destroy-on-close="true"
        :with-header="false">
        <!-- <span>products details</span> -->
        <div>
          <h1 style="text-align: center;">{{details_title}}</h1>
          <el-divider><i >{{details_message}}</i></el-divider>
          <!-- @click="previewImage('https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png')"--> 
          <img  style="display: block;width: 100%;padding:10px 20px;" v-for="o in details_imgs" :key="o"  class="details_img"
           :src="o">
            <!-- <div v-if="preview">
              <img-preview :src="src" :onClick="closeImgPreview" :onKeydown="keydownCloseImgPreview"></img-preview>
            </div> -->
        </div>
      </el-drawer>
    </div>
</template>

<script>
import lunbo_1 from '@/assets/lunbo1.jpg'
import lunbo_2 from '@/assets/lunbo2.jpg'
import jianjie from '@/assets/jianjie.png'

// pro list
import cdw_r14 from '@/assets/productList/UltralowTemperature/R14.jpg';
import cdw_r23 from '@/assets/productList/UltralowTemperature/R23.jpg';
import cdw_r508B from '@/assets/productList/UltralowTemperature/R508B.jpg';
import hnwe_r22 from '@/assets/productList/internationalBrand/hnweR22.jpg';
import hnwe_r404a from '@/assets/productList/internationalBrand/hnweR404A.jpg';
import hnwe_r410a from '@/assets/productList/internationalBrand/hnweR410A.jpg';
import km_r22 from '@/assets/productList/internationalBrand/kmR22.jpg';
import km_r410a from '@/assets/productList/internationalBrand/kmR410A.jpg';
import juhua_r22 from '@/assets/productList/juhua/juhuaR22.jpg';
import juhua_r32 from '@/assets/productList/juhua/juhuaR32.jpg';
import juhua_r134a from '@/assets/productList/juhua/juhuaR134A.jpg';
import juhua_r404a from '@/assets/productList/juhua/juhuaR404A.jpg';
import juhua_r407c from '@/assets/productList/juhua/juhuaR407C.jpg';
import juhua_r410a from '@/assets/productList/juhua/juhuaR410A.jpg';
import juhua_r507a from '@/assets/productList/juhua/juhuaR507A.jpg';
import oem_r22 from '@/assets/productList/oem/R22.jpg';import oem_r134a from '@/assets/productList/oem/R134A.jpg';
import oem_r141b from '@/assets/productList/oem/R141B.jpg';import oem_r142b from '@/assets/productList/oem/R142B.jpg';
import oem_r290 from '@/assets/productList/oem/R290.jpg';import oem_r401a from '@/assets/productList/oem/R401A.jpg';
import oem_r404a from '@/assets/productList/oem/R404A.jpg';import oem_r407c from '@/assets/productList/oem/R407C.jpg';
import oem_r410a from '@/assets/productList/oem/R410A.jpg';import oem_r417a from '@/assets/productList/oem/R417A.jpg';
import oem_r507 from '@/assets/productList/oem/R507.jpg';import oem_r600a from '@/assets/productList/oem/R600A.jpg';
//pro details
import cdw_r14_1 from '@/assets/products/UltralowTemperature/R14/1.jpg';import cdw_r14_2 from '@/assets/products/UltralowTemperature/R14/2.jpg';import cdw_r14_3 from '@/assets/products/UltralowTemperature/R14/3.jpg';
import cdw_r23_1 from '@/assets/products/UltralowTemperature/R23/1.jpg'; import cdw_r23_2 from '@/assets/products/UltralowTemperature/R23/2.jpg';import cdw_r23_3 from '@/assets/products/UltralowTemperature/R23/3.jpg';
import cdw_r508b_1 from '@/assets/products/UltralowTemperature/R508B/1.jpg';import cdw_r508b_2 from '@/assets/products/UltralowTemperature/R508B/2.jpg';import cdw_r508b_3 from '@/assets/products/UltralowTemperature/R508B/3.jpg';
import hnwe_r22_1 from '@/assets/products/internationalBrand/hnweR22/1.jpg';import hnwe_r22_2 from '@/assets/products/internationalBrand/hnweR22/2.jpg';import hnwe_r22_3 from '@/assets/products/internationalBrand/hnweR22/3.jpg';
import hnwe_r404a_1 from '@/assets/products/internationalBrand/hnweR404A/1.jpg';import hnwe_r404a_2 from '@/assets/products/internationalBrand/hnweR404A/2.jpg';import hnwe_r404a_3 from '@/assets/products/internationalBrand/hnweR404A/3.jpg';
import hnwe_r410a_1 from '@/assets/products/internationalBrand/hnweR410A/1.jpg';import hnwe_r410a_2 from '@/assets/products/internationalBrand/hnweR410A/2.jpg';import hnwe_r410a_3 from '@/assets/products/internationalBrand/hnweR410A/3.jpg';
import km_r22_1 from '@/assets/products/internationalBrand/kmR22/1.jpg';import km_r22_2 from '@/assets/products/internationalBrand/kmR22/2.jpg';import km_r22_3 from '@/assets/products/internationalBrand/kmR22/3.jpg';
import km_r410a_1 from '@/assets/products/internationalBrand/kmR410A/1.jpg';import km_r410a_2 from '@/assets/products/internationalBrand/kmR410A/2.jpg';import km_r410a_3 from '@/assets/products/internationalBrand/kmR410A/3.jpg';
import juhua_r22_1 from '@/assets/products/juhua/R22/1.jpg';import juhua_r22_2 from '@/assets/products/juhua/R22/2.jpg';import juhua_r22_3 from '@/assets/products/juhua/R22/3.jpg';
import juhua_r32_1 from '@/assets/products/juhua/R32/1.jpg';import juhua_r32_2 from '@/assets/products/juhua/R32/2.jpg';import juhua_r32_3 from '@/assets/products/juhua/R32/3.jpg';
import juhua_r134a_1 from '@/assets/products/juhua/R134A/1.jpg';import juhua_r134a_2 from '@/assets/products/juhua/R134A/2.jpg';
import juhua_r404a_1 from '@/assets/products/juhua/R404A/1.jpg';import juhua_r404a_2 from '@/assets/products/juhua/R404A/2.jpg';import juhua_r404a_3 from '@/assets/products/juhua/R404A/3.jpg';
import juhua_r407c_1 from '@/assets/products/juhua/R407C/1.jpg';import juhua_r407c_2 from '@/assets/products/juhua/R407C/2.jpg';import juhua_r407c_3 from '@/assets/products/juhua/R407C/3.jpg';
import juhua_r410a_1 from '@/assets/products/juhua/R410A/1.jpg';import juhua_r410a_2 from '@/assets/products/juhua/R410A/2.jpg';import juhua_r410a_3 from '@/assets/products/juhua/R410A/3.jpg';
import juhua_r507_1 from '@/assets/products/juhua/R507/1.jpg';import juhua_r507_2 from '@/assets/products/juhua/R507/2.jpg';import juhua_r507_3 from '@/assets/products/juhua/R507/3.jpg';
import oem_r22_1 from '@/assets/products/oem/R22/1.jpg';import oem_r22_2 from '@/assets/products/oem/R22/2.jpg';import oem_r22_3 from '@/assets/products/oem/R22/3.jpg';
import oem_r134a_1 from '@/assets/products/oem/R134A/1.jpg';import oem_r134a_2 from '@/assets/products/oem/R134A/2.jpg';import oem_r134a_3 from '@/assets/products/oem/R134A/3.jpg';
import oem_r141b_1 from '@/assets/products/oem/R141B/1.jpg';import oem_r141b_2 from '@/assets/products/oem/R141B/2.jpg';import oem_r141b_3 from '@/assets/products/oem/R141B/3.jpg';import oem_r141b_4 from '@/assets/products/oem/R141B/4.jpg';
import oem_r142b_1 from '@/assets/products/oem/R142B/1.jpg';import oem_r142b_2 from '@/assets/products/oem/R142B/2.jpg';import oem_r142b_3 from '@/assets/products/oem/R142B/3.jpg';
import oem_r290_1 from '@/assets/products/oem/R290/1.jpg';import oem_r290_2 from '@/assets/products/oem/R290/2.jpg';import oem_r290_3 from '@/assets/products/oem/R290/3.jpg';
import oem_r401a_1 from '@/assets/products/oem/R401A/1.jpg';import oem_r401a_2 from '@/assets/products/oem/R401A/2.jpg';
import oem_r404a_1 from '@/assets/products/oem/R404A/1.jpg';import oem_r404a_2 from '@/assets/products/oem/R404A/2.jpg';import oem_r404a_3 from '@/assets/products/oem/R404A/3.jpg';import oem_r404a_4 from '@/assets/products/oem/R404A/4.jpg';
import oem_r407c_1 from '@/assets/products/oem/R407C/1.jpg';import oem_r407c_2 from '@/assets/products/oem/R407C/2.jpg';
import oem_r410a_1 from '@/assets/products/oem/R410A/1.jpg';import oem_r410a_2 from '@/assets/products/oem/R410A/2.jpg';import oem_r410a_3 from '@/assets/products/oem/R410A/3.jpg';import oem_r410a_4 from '@/assets/products/oem/R410A/4.jpg';
import oem_r417a_1 from '@/assets/products/oem/R417A/1.jpg';import oem_r417a_2 from '@/assets/products/oem/R417A/2.jpg';import oem_r417a_3 from '@/assets/products/oem/R417A/3.jpg';
import oem_r507_1 from '@/assets/products/oem/R507/1.jpg';import oem_r507_2 from '@/assets/products/oem/R507/2.jpg';import oem_r507_3 from '@/assets/products/oem/R507/3.jpg';import oem_r507_4 from '@/assets/products/oem/R507/4.jpg';
import oem_r600a_1 from '@/assets/products/oem/R600A/1.jpg';import oem_r600a_2 from '@/assets/products/oem/R600A/2.jpg';


//product display
import pro_display_1 from '@/assets/productDisplay/pro_display_1.jpg';
import pro_display_2 from '@/assets/productDisplay/pro_display_2.jpg';
import pro_display_3 from '@/assets/productDisplay/pro_display_3.jpg';
import pro_display_4 from '@/assets/productDisplay/pro_display_4.jpg';
import pro_display_6 from '@/assets/productDisplay/pro_display_6.jpg';
import pro_display_7 from '@/assets/productDisplay/pro_display_7.jpg';


import bigImg from '@/components/bigImg.vue'
// import { BreedingRhombusSpinner } from 'epic-spinners'
import $ from 'jquery'
export default {
  data() {
    let self = this
    return {
      jianjie,
      preview: false,
            src:"",
      // components: {
      // BreedingRhombusSpinner
      // },
      // index : this.$route.params.index,
      animationIsShow_1:true,
      animationIsShow_2:false,
      animationIsShow_3:false,
      changeActive:0,
      menu_item:["首页","产品展示","产品列表","关于MF","联系我们"],
      pro_nav_item:[{name:'超低温系列'},{name:'国际品牌系列'},{name:'巨化系列'},{name:'中性OEM系列'}],
      current_pos:'',
      show_pros:'',
      details_title:'',
      details_message:'美氟制冷',
      details_imgs:[],
      drawer: false,
      direction:"rtl",
      screenWidth: '',
      screenHeight: '',
      card_Height:'',//卡片轮播图的高度
      list_card_style:{padding:'20px'},
      opts: {
        start: 0,
        dir: 'v',
        duration: 300,
        beforeChange: function (currentSlideEl, currenIndex, nextIndex) {},
        afterChange: function (currentSlideEl, currenIndex, nextIndex) {self.active_menu_roll(currenIndex);self.animate_isshow(currenIndex);}
      },
      pic_list: [
        lunbo_2,
        lunbo_1
      ],
      display_list:[{pic:pro_display_3,name:'巨化R134A',details:[juhua_r134a_1,juhua_r134a_2]},{pic:pro_display_2,name:'巨化R22',details:[juhua_r22_1,juhua_r22_2,juhua_r22_3]},
      {pic:pro_display_1,name:'R14',details:[cdw_r14_1,cdw_r14_2,cdw_r14_3]},{pic:pro_display_4,name:'巨化R404A',details:[juhua_r404a_1,juhua_r404a_2,juhua_r404a_3]},
      {pic:pro_display_6,name:'R23',details:[cdw_r23_1,cdw_r23_2,cdw_r23_3]},{pic:pro_display_7,name:'巨化R507A',details:[juhua_r507_1,juhua_r507_2,juhua_r507_3]}],
      display_is_open:true,
      pros_part_1:[{pic:cdw_r14,name:'R14',details:[cdw_r14_1,cdw_r14_2,cdw_r14_3]},
        {pic:cdw_r23,name:'R23',details:[cdw_r23_1,cdw_r23_2,cdw_r23_3]},{pic:cdw_r508B,name:'R508B',details:[cdw_r508b_1,cdw_r508b_2,cdw_r508b_3]}],
      pros_part_2:[{pic:hnwe_r22,name:'霍尼韦尔R22',details:[hnwe_r22_1,hnwe_r22_2,hnwe_r22_3]},{pic:hnwe_r404a,name:'霍尼韦尔R404A',details:[hnwe_r404a_1,hnwe_r404a_2,hnwe_r404a_3]},
        {pic:hnwe_r410a,name:'霍尼韦尔R410A',details:[hnwe_r410a_1,hnwe_r410a_2,hnwe_r410a_3]},{pic:km_r22,name:'科慕R22',details:[km_r22_1,km_r22_2,km_r22_3]},
        {pic:km_r410a,name:'科慕R410A',details:[km_r410a_1,km_r410a_2,km_r410a_3]}],
      pros_part_3:[{pic:juhua_r22,name:'巨化R22',details:[juhua_r22_1,juhua_r22_2,juhua_r22_3]},{pic:juhua_r32,name:'巨化R32',details:[juhua_r32_1,juhua_r32_2,juhua_r32_3]},
        {pic:juhua_r134a,name:'巨化R134A',details:[juhua_r134a_1,juhua_r134a_2]},{pic:juhua_r404a,name:'巨化R404A',details:[juhua_r404a_1,juhua_r404a_2,juhua_r404a_3]},
        {pic:juhua_r407c,name:'巨化R407C',details:[juhua_r407c_1,juhua_r407c_2,juhua_r407c_3]},{pic:juhua_r410a,name:'巨化R410A',details:[juhua_r410a_1,juhua_r410a_2,juhua_r410a_3]},
        {pic:juhua_r507a,name:'巨化R507A',details:[juhua_r507_1,juhua_r507_1,juhua_r507_1]}],
      pros_part_4:[{pic:oem_r22,name:'R22',details:[oem_r22_1,oem_r22_2,oem_r22_3]},{pic:oem_r134a,name:'R134A',details:[oem_r134a_1,oem_r134a_2,oem_r134a_3]},
        {pic:oem_r141b,name:'R141B',details:[oem_r141b_1,oem_r141b_2,oem_r141b_3,oem_r141b_4]},{pic:oem_r142b,name:'R142B',details:[oem_r142b_1,oem_r142b_2,oem_r142b_3]},
        {pic:oem_r290,name:'R290',details:[oem_r290_1,oem_r290_2,oem_r290_3]},{pic:oem_r401a,name:'R401A',details:[oem_r401a_1,oem_r401a_2]},
        {pic:oem_r404a,name:'R404A',details:[oem_r404a_1,oem_r404a_2,oem_r404a_3,oem_r404a_4]},{pic:oem_r407c,name:'R407C',details:[oem_r407c_1,oem_r407c_2]},
        {pic:oem_r410a,name:'R410A',details:[oem_r410a_1,oem_r410a_2,oem_r410a_3,oem_r410a_4]},{pic:oem_r417a,name:'R417A',details:[oem_r417a_1,oem_r417a_2,oem_r417a_3]},
        {pic:oem_r507,name:'R507',details:[oem_r507_1,oem_r507_2,oem_r507_3,oem_r507_4]},{pic:oem_r600a,name:'R600A',details:[oem_r600a_1,oem_r600a_2]}]
    }
  },
  methods: {
    changeFun(val,oldVal){
      this.display_is_open = false;
      // console.log(`var: ${val}, oldVal: ${oldVal}`);
    },
    linkTo(){
      let activeIndex = this.$refs.carousel.activeIndex;
      setTimeout(() =>{
        if(this.display_is_open){
          this.details_imgs = this.display_list[activeIndex].details;
          this.details_title = this.display_list[activeIndex].name;
          this.drawer = true;
        }
        this.display_is_open = true;
      },100);
    },
    moveNext() {
      this.$refs.example.$fullpage.moveNext(); //Move to the next page
    },
    active_menu_roll(index){
      this.changeActive= index;
    },
    active_menu(index){
      this.changeActive= index;
      this.$refs.example.$fullpage.moveTo(index,true ,true);
      // if(this.menu_item[index]=='产品列表'){
      //   this.changeActive= index;
      //   this.$router.push('proList');
      // }else{
      //   this.changeActive= index;
      //   this.$refs.example.$fullpage.moveTo(index,true ,true);
      // }
    },
    goto_prolist(){
      this.active_menu(this.menu_item.indexOf('产品列表'));
            // alert(666);
      // this.$router.push({
      //   name:'proList',
      //   params:{
      //     id:123
      //   }
      // });
    },
    animate_isshow(index){
      if(index==0){
        this.animationIsShow_1 = true;
        this.animationIsShow_2=false;
        this.animationIsShow_3 = false;
      }else if(index==1){
        this.animationIsShow_2 = true;
        this.animationIsShow_1 = false;
        this.animationIsShow_3 = false;
      }else if(index==2){
        this.animationIsShow_3 = true;
        this.animationIsShow_1 = false;
        this.animationIsShow_2=false;
      }else{
        this.animationIsShow_3 = false;
        this.animationIsShow_1 = false;
        this.animationIsShow_2=false;
      }
    },
    handleSelect(key, keyPath) {
      let arr = [this.pros_part_1,this.pros_part_2,this.pros_part_3,this.pros_part_4];
      this.current_pos =  arr[key];
      this.show_pros = arr[key].slice(0);
    },
    current_change(index){
      index = index-1;//翻页的角标是从1开始
      let arr = [this.pros_part_1,this.pros_part_2,this.pros_part_3,this.pros_part_4];
      this.show_pros = this.current_pos.slice(0).splice(8*index,this.current_pos.length-8*index>8?8:this.current_pos.length-index*8);
      // console.log(this.show_pros);
      // let arr = [this.pros_part_1,this.pros_part_1,this.pros_part_1,this.pros_part_1];
      // this.pros_pos = arr[index].length;
      // this.pros_pos = this.pros_pos-8*(index-1);
      // console.log(index);
    },
    single_pro_click(index){
      // console.log(index);
      // if(index%4==2 || index%4==3){
      //   this.direction ="ltr";
      // }else{
      //   this.direction="rtl";
      // }
      this.details_imgs = this.show_pros[index].details;
      this.details_title = this.show_pros[index].name;
      this.drawer = true;
    },
    previewImage(src) {
      this.preview = true;
      this.src = src;
    },
    keydownCloseImgPreview(e) {
      if (e && e.keyCode == 27) {
        this.preview = false;
      }
    },
    closeImgPreview() {
      this.preview = false;
    }
  },
  mounted(){
          console.log(`◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇
      ◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇
      ◇◇◆◆◆◆◇◇◇◇◆◆◆◇◇◇◇◇◆◆◆◆◆◆◆◆◆◇◇◇
      ◇◇◇◆◆◆◇◇◇◇◆◆◇◇◇◇◇◇◇◆◆◆◇◇◇◆◆◇◇◇
      ◇◇◇◇◆◆◆◇◇◆◆◆◇◇◇◇◇◇◇◇◆◇◇◇◆◆◆◇◇◇
      ◇◇◇◇◆◆◆◇◇◆◆◆◇◇◇◇◇◇◇◇◆◇◇◇◆◆◇◇◇◇
      ◇◇◇◇◆◆◆◆◇◆◇◆◇◇◇◇◇◇◇◇◆◆◆◆◆◆◇◇◇◇
      ◇◇◇◇◆◇◆◆◆◆◇◆◇◇◇◇◇◇◇◇◆◇◇◇◆◆◇◇◇◇
      ◇◇◇◇◆◇◆◆◆◇◇◆◇◇◇◇◇◇◇◇◆◇◇◇◇◇◇◇◇◇
      ◇◇◇◇◆◇◇◆◆◇◇◆◇◇◇◇◇◇◇◇◆◇◇◇◇◇◇◇◇◇
      ◇◇◆◆◆◆◇◆◆◆◆◆◆◇◇◇◇◇◆◆◆◆◆◇◇◇◇◇◇◇
      ◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◆◆◆◆◆◇◇◇◇◇◇◇
      ◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇
      ◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇
      ◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇`);
      // if(this.index!=void 0){
      //   console.log('index:',this.index);
      //   this.active_menu(this.index);
      // }
      this.show_pros = this.pros_part_1.slice(0);;
      this.current_pos = this.pros_part_1
      $(".connect_icon").hover(function(){
            $(".phone_number").stop().animate({
              opacity:'1',
              with:'300px'
            });
      },function(){
            $(".phone_number").stop().animate({
              opacity:'0',
              with:'300px'
            });
      })
      this.screenWidth = document.body.clientWidth + 'px';
      this.screenHeight = document.body.clientHeight + 'px';
      if(document.body.clientHeight>750){
        this.card_Height = document.body.clientHeight*0.5 +'px';
      }else{
      this.card_Height = document.body.clientHeight*0.5 +'px';
      }
      if(document.body.clientHeight<700){
        this.list_card_style = {padding:"20px"};
      }else if(document.body.clientHeight<820){
        this.list_card_style = {padding:"0px"};
      }else{
        this.list_card_style={padding:"20px"};
      }
      window.onresize = () => {
          return (() => {
              this.screenWidth = document.body.clientWidth + 'px';
              this.screenHeight = document.body.clientHeight + 'px';
                    // console.log(this.screenHeight);
              if(document.body.clientHeight>750){
                this.card_Height = document.body.clientHeight*0.5 +'px';
              }else{
              this.card_Height = document.body.clientHeight*0.5 +'px';
              }
              if(document.body.clientHeight<700){
                this.list_card_style = {padding:"20px"};
              }else if(document.body.clientHeight<820){
                this.list_card_style = {padding:"0px"};
              }else{
                this.list_card_style={padding:"20px"};
              }
          })();
      };
  },
  components:{
    "img-preview": bigImg
  }
}
</script>

<style scoped>
  /* .details_img:hover{
    cursor: pointer;
  } */
  /deep/ .d_aa{
    overflow-y: scroll;
    /* background: seagreen; */
  }
  .xiala-icon{
    width: 48px;
    height: 38px;
    background-image: url('~@/assets/xiala.png');
    background-repeat: no-repeat;
    background-size: 100%;
    position: absolute;
    bottom: 40px;
    left: 50%;
    margin-left: -24px;
    /* -webkit-animation: Brand-arrowing-1L7rV 3s infinite;
    animation: Brand-arrowing-1L7rV 3s infinite; */
    z-index: 9998;
  }
  .main {
    height: 100%;
  }
  .page-2 {
    /* background-color: pink; */
    background-image: url('~@/assets/bg_2.jpg');
  }
   .page-3 {
    background-color: #ffa500;
    background-image: url('~@/assets/bg_3.jpg');
    background-repeat: no-repeat;
    background-size: cover;
  }
  .page-4 {
    /* background-color: grey; */
    background: url('~@/assets/bg_4.jpg') center center;
    background-size: cover;      /* 覆盖:图片成比例填满盒子。可用于适配 */
    /* background-size: contain; */
    background-repeat: no-repeat;
  }
  .jianjie{
    width: 1000px;
    height: 500px;
    /* background: olivedrab; */
        /* background: url('~@/assets/jianjie.png') center center; */
    /* background-size: cover;      /* 覆盖:图片成比例填满盒子。可用于适配 */
    /* background-size: contain; */
    /* background-repeat: no-repeat; */ 
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 24%;
  }
  .page-5 {
    /* background-color: rgb(180, 224, 98); */
    background-image: url('~@/assets/bg_5.jpg');
  }
  .connect_us{
    /* background-color: cadetblue; */
    background-image: url('~@/assets/connect_bg.jpg');
    background-size: 200px 200px;  /* 通过像素设置 */
    background-size: 50% 50%;    /* 通过百分比设置 */
    background-size: cover;      /* 覆盖:图片成比例填满盒子。可用于适配 */
    background-size: contain;
    box-shadow:0 0 9px 3px #7b7777;
    padding: 10px;
    /* height: 71%; */
    width: 1024px;
    margin: 270px auto;
  }
  .connect_us ul li{
    color: white;
    padding: 20px;
    font-family: monospace;
    font-weight: 700;
    font-size: large;
  }
  .beian{
    color: white;
    display: inline-block;
    margin-left: 48%;
    margin-top: 49px;
  }
  .item_name{
    padding-top: 20px;
    padding-bottom: 10px;
    /* background-color: #7bb1e0a8; */
    text-align: center;
  }
  .image:hover{
      transform: scale(1.2);
      -ms-transform: scale(1.2);
      cursor: pointer;
  }
  .pro-nav{
    /* display: inline-block; */
    width: 80%;
    margin: 0 auto;
    padding: 20px;
    margin-top: 200px;
    /* height: 100px; */
    box-shadow:0 0 9px 3px #7b7777;
    /* background-color:#a08bb5d6; */
    /* background-image: url('~@/assets/list_bg.jpg'); */
    border-radius:10px;
   
  }
  .el-menu{
    border-right:none
  }
  .pro-area{
    /* display: inline-block; */
    float: right;
    padding: 10px 10px;
    width: 60%;
    height: 70%;
    margin-top: 15%;
    margin-right:10%;
    /* height: 100px; */
    box-shadow:0 0 9px 3px #7b7777;
    background-color:#a08bb5d6;
  }
  .el-container {
    height: 100%;
  }
  .more-pro{
    background-color: #ff6e0d;
    width: 100px;
    /* height: 100px; */
    margin: 0 auto;
    padding: 30px;
    text-align: center;
    cursor:pointer;
    /* margin-top:40px; */
    /* display: inline-block; */
    border-radius: 2px;
    /* width: 260px;
    height: 90px;
    line-height: 90px; */
    color: #fff;
    font-size: 16px;
    font-weight: 700;
    text-decoration: none;

  }
  .more-pro:hover{
    background:-webkit-gradient(linear, 0 0, 0 0, from(#ff6e0d), to(#ff6e0da1));
    /* background-color:rgba(228, 137, 52, 0.82); */
  }
  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 800px;
    margin: 0;
  }
  
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
 .time {
    font-size: 13px;
    color: #999;
  }
  
  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    display: block;
    height: 225.61px;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }
  
  .clearfix:after {
      clear: both
  }

.element-animation{
  animation: animationFrames ease 3s;
  animation-iteration-count: infinite;
  transform-origin: 50% 50%;
  -webkit-animation: animationFrames ease 3s;
  -webkit-animation-iteration-count: infinite;
  -webkit-transform-origin: 50% 50%;
  -moz-animation: animationFrames ease 3s;
  -moz-animation-iteration-count: infinite;
  -moz-transform-origin: 50% 50%;
  -o-animation: animationFrames ease 3s;
  -o-animation-iteration-count: infinite;
  -o-transform-origin: 50% 50%;
  -ms-animation: animationFrames ease 3s;
  -ms-animation-iteration-count: infinite;
  -ms-transform-origin: 50% 50%;
}
@media only screen and (max-height: 820px) {
  /* .pro-nav{
    height: 700px;
  } */
  .item_name{
    padding-top: 0px;
    padding-bottom: 0px;
  }
}
@media only screen and (max-height: 700px) {
  /* .pro-nav{
    height: 700px;
  } */
  .image{
    height: 100px;
  }
  .item_name{
    padding-top: 8px;
    padding-bottom: 0px;
  }
  .connect_us{
        margin: 14% auto;
  }
  .beian{
    margin-left:38%;
    margin-top: 65px;
  }
}

@keyframes animationFrames{
  0% {
    transform:  translate(0px,0px)  ;
  }
  50% {
    transform:  translate(0px,22px)  ;
  }
  100%{
      transform:  translate(0px,0px)  ;
  }
}

@-moz-keyframes animationFrames{
  0% {
    -moz-transform:  translate(0px,0px)  ;
  }
  50% {
    -moz-transform:  translate(0px,22)  ;
  }
    100%{
      -moz-transform:  translate(0px,0px)  ;
  }
}

@-webkit-keyframes animationFrames {
  0% {
    -webkit-transform:  translate(0px,0px)  ;
  }
  50% {
    -webkit-transform:  translate(0px,22)  ;
  }
    100%{
      -webkit-transform:  translate(0px,0px)  ;
  }
}

@-o-keyframes animationFrames {
  0% {
    -o-transform:  translate(0px,0px)  ;
  }
  50% {
    -o-transform:  translate(0px,22px)  ;
  }
    100%{
      -o-transform:  translate(0px,0px)  ;
  }
}

@-ms-keyframes animationFrames {
  0% {
    -ms-transform:  translate(0px,0px)  ;
  }
  50% {
    -ms-transform:  translate(0px,22px)  ;
  }
    100%{
      -ms-transform:  translate(0px,0px)  ;
  }
}
.aaa{
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue